import { Box, Stack, Tooltip, Typography } from '@mui/material';

interface ReprtGraphLegendProps {
  legends: string[];
  tooltipText: string[];
  colors: string[];
  align: string;
}

const headerText = {
  fontSize: '18px',
  fontWeight: 500,
};

const getLegendColor = ( index: number, colors: string[]) => {
  const totalColors = colors.length;
  if (index < totalColors)
    return colors[index];
  return colors[index % totalColors];
};

const ReportGraphLegend = ({ legends, tooltipText, colors, align }: ReprtGraphLegendProps) => {

  return (
    <Stack direction='row' alignItems='center' justifyContent={align} flexWrap='wrap' gap={1}>
      {
        legends.map((legend, index) => (
          <Tooltip title={tooltipText[index]} key={index}>
            <Stack direction='row' alignItems='center'>
              <Box sx={{
                width: '12px',
                height: '12px',
                borderRadius: '2px',
                backgroundColor: getLegendColor(index, colors),
                margin: '0px 4px 1px 0px',
              }}/>
              <Typography sx={{
                ...headerText,
                fontSize: '12px',
              }}>{legend}</Typography>
            </Stack>
          </Tooltip>
        ))
      }
    </Stack>
  );
};

export default ReportGraphLegend;